module.exports = "#button-container{display:flex;justify-content:center;align-items:center}\n"